import Glide from "@glidejs/glide";
import useNcId from "hooks/useNcId";
import React, { FC, useEffect, useMemo } from "react";
import NcImage from "shared/NcImage/NcImage";
import NextPrev from "shared/NextPrev/NextPrev";
import { Link } from "react-router-dom";
import { EyeIcon, EyeSlashIcon } from "@heroicons/react/24/outline";
import { useLocation } from "react-router-dom";

import Tooltip from "@mui/material/Tooltip";
export interface GallerySliderProps {
  className?: string;
  galleryImgs: string[];
  ratioClass?: string;
  uniqueID: string;
  href?: string;
  propertyId?: string;
  viewsCount?: number;
  toggleVisibility?: any;
  isVisible?: boolean;
  setIsVisible?: any;
}

const GallerySlider: FC<GallerySliderProps> = ({
  className = "",
  galleryImgs,
  ratioClass = "aspect-w-4 aspect-h-3",
  uniqueID = "uniqueID",
  href = "/detail",
  propertyId,
  viewsCount,
  toggleVisibility,
  isVisible,
}) => {
  const UNIQUE_CLASS = `gallerySlider__${uniqueID}` + useNcId();
  let MY_GLIDEJS = useMemo(() => {
    return new Glide(`.${UNIQUE_CLASS}`, {
      perView: 1,
      gap: 0,
      keyboard: false,
    });
  }, [UNIQUE_CLASS]);
  useEffect(() => {
    if (Array.isArray(galleryImgs) && galleryImgs.length > 0) {
      MY_GLIDEJS.mount();
    } else {
      console.warn("galleryImgs is empty or not an array.");
    }
  }, [MY_GLIDEJS, UNIQUE_CLASS, galleryImgs]);

const location = useLocation();
const isAddOrEditPage = location.pathname === `/edit-property/${propertyId}`;
const isAddpropPage = location.pathname === "/add-property";


  const renderDots = () => {
    return (
      <div
        className="glide__bullets flex items-center justify-center absolute bottom-2 left-1/2 transform -translate-x-1/2 space-x-1.5"
        data-glide-el="controls[nav]"
      >
        {galleryImgs.map((_, i) => (
          <button
            className="glide__bullet w-1.5 h-1.5 rounded-full bg-neutral-300"
            key={i}
            data-glide-dir={`=${i}`}
          />
        ))}
      </div>
    );
  };

  const renderSliderGallery = () => {
    return (
      <div className={`${UNIQUE_CLASS} relative group overflow-hidden`}>
        <div className="glide__track" data-glide-el="track">
          <ul className="glide__slides">
            {galleryImgs.map((item, index) => (
              <li key={index} className="glide__slide relative">
                <Link to={href} className={`block ${ratioClass}`}>
                  <NcImage src={item} />
                </Link>
              </li>
            ))}
          </ul>
        </div>
        {(viewsCount != undefined && viewsCount > 0) && (
          <span
            className="absolute bottom-[12px] left-2 z-max text-xs opacity-75 border rounded-md border-white max-w-fit px-2 text-center text-white"
            style={{
              background: "#1A1C1D66",
              backdropFilter: "blur(4px)",
            }}
          >
            {viewsCount} views
          </span>
        )}
{ !isAddOrEditPage && !isAddpropPage && (
       <Tooltip
                  title={`${isVisible ? "Hide Property" : "Show property"}`}
                  placement="right-end"
                >
                  <button
                    className="absolute !w-8 h-8 bg-white top-2 left-[350px] md:top-2 md:inset-[300px] xl:top-2 xl:inset-[247px] lg:top-2 lg:inset-[260px] rounded-md hover:bg-slate-100"
                    onClick={() => {
                      toggleVisibility();
                    }}
                  >
                    {isVisible ? (
                      <EyeIcon className="h-4 w-4 m-auto text-black" />
                    ) : (
                      <EyeSlashIcon className="h-4 w-4 m-auto text-black" />
                    )}
                  </button>
                </Tooltip>
)}
        {/* DOTS */}
        <div className="absolute -bottom-4 inset-x-0 h-10 bg-gradient-to-t from-neutral-900"></div>
        {renderDots()}

        {/* NAV */}
        <div className="absolute opacity-0 group-hover:opacity-100 transition-opacity flex top-1/2 transform -translate-y-1/2 inset-x-2 justify-between">
          <NextPrev
            className="w-full justify-between"
            btnClassName="w-8 h-8"
            propertyId={propertyId}
          />
        </div>
      </div>
    );
  };

  return (
    <div className={`nc-GallerySlider ${className}`} data-nc-id="GallerySlider">
      {renderSliderGallery()}
    </div>
  );
};

export default GallerySlider;
